import { render, staticRenderFns } from "./OnboardingCompanyPage.vue?vue&type=template&id=c3c5b372&scoped=true&"
import script from "./OnboardingCompanyPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingCompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCompanyPage.vue?vue&type=style&index=0&id=c3c5b372&prod&lang=scss&"
import style1 from "./OnboardingCompanyPage.vue?vue&type=style&index=1&id=c3c5b372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c5b372",
  null
  
)

export default component.exports